import React from 'react'
import Spacer from '../../../components/Spacer';
import Info from './Info';
import Cards from './Cards';
import Banner from '../../../components/Banner';


function Regulations() {
  return (
    <>
    <Banner titleSection={'NORMATIVAS'} linkName={'Inicio'} nameSection={'Normativas'} />
    <Spacer/>
    <Info/>
    <Spacer/>
    <Cards/>
    <Spacer/>
    </>
  )
}

export default Regulations